// react
import { useState } from 'react';

// i18n
import { useTranslation } from 'react-i18next';

// dialogs
import { DialogActions, DialogActionsProps } from '../DialogActions/DialogActions';

// forms
import { FormEditSupplier } from '../../forms/FormEditSupplier/FormEditSupplier';

// props
export interface DialogEditSupplierProps {
	DialogActionsProps?: Partial<DialogActionsProps>;
	isOpen: boolean;
	onClose: () => void;
	onSuccess?: () => void;
}

export const DialogEditSupplier = ({
	DialogActionsProps = {},
	isOpen,
	onClose,
	onSuccess,
}: DialogEditSupplierProps) => {
	// hooks
	const { t } = useTranslation();

	// state
	const [isLoading, setIsLoading] = useState(false);

	DialogActionsProps.actions = [
		{
			children: t('cancel'),
			onClick: onClose,
		},
		{
			children: t('saveSupplier'),
			loading: isLoading,
			form: 'form-edit-supplier',
			type: 'submit',
			variant: 'contained',
		},
	];
	DialogActionsProps.title = {
		children: t('editSupplier'),
		variant: 'h3',
	};
	return (
		<DialogActions hasClose={true} isOpen={isOpen} onClose={onClose} {...DialogActionsProps}>
			<FormEditSupplier onClose={onClose} onSuccess={onSuccess} setIsLoading={setIsLoading} />
		</DialogActions>
	);
};
